var utils = require(/*! ./utils */"./utils.js");
module.exports = function () {
  this.locale = 'en';
  this.supported = ['en'];
  this.translations = {};
  for (var i = 0; i < this.supported.length; i++) {
    // this.translations[this.supported[i]] = require("./i18n sync recursive ^\\.\\/.*\\.js$.js")("./" + this.supported[i] + ".js");
    this.translations[this.supported[i]] = require("./i18n/" + this.supported[i] + ".js");
  }
  this.setLocale = function (l) {
    if (this.supported.indexOf(l) > -1) {
      this.locale = l;
    }
  };
  this.setLocaleFromStorage = function () {
    if (typeof Storage !== "undefined") {
      this.setLocale(localStorage.getItem("krk_lang"));
    }
  };
  this.setLocaleFromStorage();
  this.get = function (key) {
    //var locale = this.locale;
    //if (this.supported.indexOf(l) > -1) locale = l;
    let tmp = this.translations[this.locale][key] || 'UNLOCALIZED STRING';
    for (var i = 1; i < arguments.length; i++) {
      tmp = tmp.replace('{' + (i - 1) + '}', arguments[i]);
    }
    return tmp;
  };
};